export default __webpack_public_path__ + "static/img-projects-02-thumb-ee841644d2bda160401bf7fae9f3dc0d.png";